// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__1IPGy","content":"Contact_content__8b7ft"};